<template>
  <div>
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="labelTipoResultado"
      :multiple="isMulti"
      :taggable="isTagabble"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="false"
      :preselectFirst="true"
      :loading="isLoading"
      label="nome"
      track-by="id"
      :disabled="isDisabled || forceDisabled || isLoading || !this.tipoSub"
      :placeholder="forceDisabled ? $t('Tipo subevento não possui opções') : ''"
    >
      <template slot="noResult" slot-scope="props">
        <span>{{ $t('Nenhum elemento encontrado.') }}</span>
      </template>
      <template slot="noOptions" slot-scope="props">
        <span>{{ $t('Nenhum dado foi retornado.') }}</span>
      </template>
      <template slot="tag" slot-scope="{ option }"
        ><span class="badge badge-primary mr-1"
          ><span class="text-truncate mr-1 mb-1">{{ option.nome }}</span
          ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
        ></template
      >
      <template slot="clear" slot-scope="props">
        <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';

const layoutsSemOpcoes = [1, 4];

export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'tipoSub'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false,
      forceDisabled: false,
      dados: null
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e === null || e === undefined) {
        this.$emit('selectChange', 'tipo_resultado', null);
        return;
      }
      this.$emit('selectChange', 'tipo_resultado', e);
    },
    labelTipoResultado({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'tipo_resultado', value);
      } else {
        if (value) {
          if (value.id) {
            this.selected = this.options.find((option) => option.id === value.id);
          } else {
            this.selected = this.options.find((option) => option.id === value);
          }
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
        this.$emit('input', this.selected);
      }
    },
    clearAll() {
      this.value = [];
    },
    setOptions() {
      this.options = [];
      if (!this.tipoSub) return;
      this.isLoading = true;
      this.$atenaList
        .getCommon(`subevento/opcoes?tipoSub=${this.tipoSub}`)
        .then((res) => {
          this.dados = res;
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }

          this.forceDisabled = layoutsSemOpcoes.includes(res?.idLayout);

          this.options = this.options.concat(this.createOptions(res) || []);

          // remover ids duplicados
          this.options = this.options.filter(
            (option, index, self) => index === self.findIndex((t) => t.id === option.id)
          );

          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    createOptions(res) {
      if (!res?.idLayout) return [];

      let opcoes = [];

      switch (res.idLayout) {
        case 1:
          opcoes = res.opcoes.map((o) => {
            return {
              id: o.tipoResultado,
              nome: o.descricao
            };
          });
          return opcoes;

        case 5:
          let opcoes = [];

          let min = res.opcoes[0].inicio;
          let max = res.opcoes[0].fim;
          let variacao = res.opcoes[0].variacao;

          //opcoes abaixo
          for (let i = max; i >= min; i -= variacao) {
            opcoes.push({
              id: `${i * -1}`,
              nome: '-' + i
            });
          }

          //opcoes acima
          for (let i = min; i <= max; i += variacao) {
            opcoes.push({
              id: `${i}`,
              nome: '+' + i
            });
          }
          return opcoes;

        case 4:
          opcoes = [
            {
              id: 9,
              nome: 'Sim'
            },
            {
              id: 10,
              nome: 'Não'
            }
          ];

          return opcoes;

        case 8:
          let opcoesHandicap = [];

          //opcoes fora
          let minFora = res.opcoes[1].inicio;
          let maxFora = res.opcoes[1].fim;
          let variacaoFora = res.opcoes[1].variacao;

          for (let i = minFora; i <= maxFora; i += variacaoFora) {
            opcoesHandicap.push({
              id: i,
              nome: 'Fora ' + i
            });
          }

          opcoesHandicap.forEach((o) => {
            opcoesHandicap.push({
              id: o.id * -1,
              nome: 'Casa ' + o.id * -1
            });
          });

          opcoes = [...opcoesHandicap];
          return opcoes;

        case 2:
          opcoes = [];

          //HANDICAP EUROPEU (+1, +2, +3, +4, +5, +6, +7, +8, +9 / -1, -2, -3, -4, -5, -6, -7, -8, -9)
          let europeanMin = res.opcoes[0].inicio;
          let europeanMax = res.opcoes[0].fim;
          let europeanVariacao = res.opcoes[0].variacao;

          for (let i = europeanMin; i <= europeanMax; i += europeanVariacao) {
            opcoes.push({
              id: i,
              nome: '+' + i
            });
          }

          for (let i = europeanMin; i <= europeanMax; i += europeanVariacao) {
            opcoes.push({
              id: i * -1,
              nome: '-' + i
            });
          }

          return opcoes;

        default:
          return opcoes;
      }
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });

      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    tipoSub: function (value) {
      this.setOptions();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
